import { baseFetch, baseSubmit } from "../utils/Fetch";
import { removeSurroundingQuotes, cleanupFilename, localhostLogFetch } from "../utils/General";
import { RootStore } from './../stores/RootStore';

export class BaseApiService {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  showApiError(data: any) {
    const errorCode = this.getErrorCode(data);
  }

  showApiAccessDenied(data?: any) { // TODO klopt het dat dit nullable is?
    const errorCode = this.getErrorCode(data);
  }

  failed() {
    return { success: false, data: undefined };
  }

  isSuccessResponse(response: any) {
    return response.status >= 200 && response.status < 300;
  }

  async put(url: string, data: any, silentError?: any) {
    const response = await baseSubmit("PUT", url, this.rootStore.authorizationStore.getToken(), data);
    if (response) {
      const { success } = await this.processResponse(response, silentError);
      return success;
    }
    this.showApiAccessDenied();
    return false;
  }

  async post(url: string, data: any, silentError?: any) {
    const response = await baseSubmit("POST", url, this.rootStore.authorizationStore.getToken(), data);
    if (response) {
      const { success, data } = await this.processResponse(response, silentError);
      return { success, data };
    }
    this.showApiAccessDenied();
    return this.failed();
  }

  async get(url: string, silentError?: any) { // TODO nullable?
    const response = await baseFetch("GET", url, this.rootStore.authorizationStore.getToken());
    if (response) {
      const { success, data } = await this.processResponse(response, silentError);
      return { success, data };
    }
    this.showApiAccessDenied();
    return this.failed();
  }

  async delete(url: string, silentError?: any) {
    const response = await baseFetch("DELETE", url, this.rootStore.authorizationStore.getToken());
    if (response) {
      const { success } = await this.processResponse(response, silentError);
      return success;
    }
    this.showApiAccessDenied();
    return false;
  }

  getFilenameFromHeaders(headers: any) {
    const items = (headers.get("Content-Disposition") || "").split("filename=");
    const result = items.length > 1
      ? cleanupFilename(items[1])
      : null;
    return result || "attachment.data";
  }

  getErrorCode(data: any) {
    return data && data.Errors && data.Errors[0] && data.Errors[0].ErrorCode
      ? "API_Error_" + data.Errors[0].ErrorCode
      : undefined;
  }


  setToken(response: any) {
    if (response) {
      const newToken = response.headers.get("set-authentication");
      if (newToken)
        this.rootStore.authorizationStore.setToken(newToken);
    }
  }


  async processResponse(response: any, silentError: any) {
    this.setToken(response);
    const success = this.isSuccessResponse(response);
    const data = await this.getJsonOrText(response);
    if (!success && !silentError) this.showApiError(data);
    return { success, data };
  }

  async getJsonOrText(response: any) {
    const text = await response.text();
    try {
      return JSON.parse(text);
    } catch {
      return removeSurroundingQuotes(text);
    }
  }
}